import { Button } from 'antd';
import { useLocation } from 'react-router-dom';

import { CustomAlert } from '@app/components/CustomAlert';
import type { NEditPageButtons } from '@app/components/EditPageButtons/EditPageButtons.types';
import {
  RIGHTS_CLIENT_SERVICES,
  RIGHTS_IS_DELETE,
  RIGHTS_LEGAL_ENTITIES,
  RIGHTS_PAYMENT_ACCOUNTS,
  RIGHTS_POSITIONS,
} from '@app/constants/accessRights';
import {
  EDIT_CATEGORY_PATH,
  LEGAL_ENTITIES_PATH,
  PAYMENTS_ACCOUNTS_PATH,
  POSITIONS_PATH,
} from '@app/constants/navigation';
import { useAccessRights } from '@app/hooks';

import '@app/components/EditPageButtons/styles/EditPageButtons.mobile.scss';
import '@app/components/EditPageButtons/styles/EditPageButtons.desktop.scss';

export const EditPageButtons: NEditPageButtons.Main = ({
  serverError,
  errorType,
  setServerError,
  isLoading,
  setModalOpen,
  handleCancel,
  isEditPage,
}) => {
  const { pathname } = useLocation();
  const isEditingLegalEntitiesPage = pathname.includes(LEGAL_ENTITIES_PATH);
  const isEditingPositionsPage = pathname.includes(POSITIONS_PATH);
  const isEditingPaymentsAccountPage = pathname.includes(
    PAYMENTS_ACCOUNTS_PATH
  );
  const isEditServiceCategoryPage = pathname.includes(EDIT_CATEGORY_PATH);

  const { hasUserRight: hasUserRightToDeletePosition } = useAccessRights(
    RIGHTS_POSITIONS,
    RIGHTS_IS_DELETE
  );
  const { hasUserRight: hasUserRightToDeleteLegalEntities } = useAccessRights(
    RIGHTS_LEGAL_ENTITIES,
    RIGHTS_IS_DELETE
  );
  const { hasUserRight: hasUserRightToDeletePaymentsAccount } = useAccessRights(
    RIGHTS_PAYMENT_ACCOUNTS,
    RIGHTS_IS_DELETE
  );
  const { hasUserRight: hasUserRightToDeleteServiceCategory } = useAccessRights(
    RIGHTS_CLIENT_SERVICES,
    RIGHTS_IS_DELETE
  );

  const showDeleteButton =
    (isEditingLegalEntitiesPage && hasUserRightToDeleteLegalEntities) ||
    (isEditingPositionsPage && hasUserRightToDeletePosition) ||
    (isEditingPaymentsAccountPage && hasUserRightToDeletePaymentsAccount) ||
    (isEditServiceCategoryPage && hasUserRightToDeleteServiceCategory);

  return (
    <div className="form-buttons">
      {serverError && (
        <CustomAlert
          errorType={errorType}
          serverError={serverError}
          setServerError={setServerError}
        />
      )}

      <div>
        {isEditPage ? (
          <div className="button-container">
            <div className="first-button-group">
              <Button
                type="primary"
                htmlType="submit"
                className="action-button"
                loading={isLoading}
                size="large"
                data-testid="save"
              >
                Сохранить
              </Button>

              <Button
                className="action-button"
                disabled={isLoading}
                size="large"
                onClick={handleCancel}
                data-testid="cancel"
              >
                Отменить
              </Button>
            </div>
            {showDeleteButton && (
              <Button
                danger
                className="action-button"
                disabled={isLoading}
                size="large"
                onClick={() => setModalOpen && setModalOpen(true)}
                style={{ width: 'auto' }}
                data-testid="delete"
              >
                Удалить
              </Button>
            )}
          </div>
        ) : (
          <div className="first-button-group">
            <Button
              type="primary"
              htmlType="submit"
              className="action-button"
              loading={isLoading}
              size="large"
              data-testid="save"
            >
              Сохранить
            </Button>

            <Button
              className="action-button"
              disabled={isLoading}
              size="large"
              onClick={handleCancel}
              data-testid="cancel"
            >
              Отменить
            </Button>
          </div>
        )}
      </div>
    </div>
  );
};
